"use strict";

angular.module("models").service("LalCostsService", function () {
  var _this = this;

  var cleanId = function cleanId(id) {
    return String(id || "").replace(/^\$/, "");
  };
  var round = function round(value) {
    return Math.round(value * 100) / 100;
  };
  var hasAmount = function hasAmount(value) {
    return typeof value === "number" && isFinite(value);
  };

  // A LAL is a financial dossier, not an amount to repeat for each damage.
  // Keep historical links (including deleted damages); never allocate a fraction
  // based on the current period, filters, or the user's visible damage subset.
  this.detachSharedCost = function (damage, lal, preserveInputs) {
    delete damage.sharedLalCost;
    damage.costContext = "Coût individuel";
    var ids = Array.from(new Set((lal && lal.damageIds || []).map(cleanId).filter(Boolean)));
    if (!lal || ids.length < 2 || !ids.includes(cleanId(damage._id)) || !hasAmount(lal.costTotal) && !hasAmount(lal.costDeductible)) return;

    var insurer = hasAmount(lal.costTotal) ? round(lal.costTotal) : 0;
    var deductible = hasAmount(lal.costDeductible) ? round(lal.costDeductible) : 0;
    damage.sharedLalCost = {
      id: cleanId(lal._id), ref: lal.refInsurer || cleanId(lal._id),
      insurer: insurer, deductible: deductible, total: round(insurer + deductible),
      dateDamage: lal.dateDamage
    };
    damage.costContext = "Frais propres uniquement — coût commun " + damage.sharedLalCost.ref;
    if (hasAmount(lal.costTotal)) {
      damage.newCostInsurer = round((damage.newCostInsurer || 0) - insurer);
      damage.costTotalLal = 0;
    }
    if (deductible) {
      damage.newCostCompagny = round((damage.newCostCompagny || 0) - deductible);
      if (!preserveInputs) damage.costDeductible = 0;
      damage.lalCostDeductible = 0;
    }
    damage.newCostTotal = round((damage.newCostCompagny || 0) + (damage.newCostInsurer || 0));
  };

  this.withCommonRows = function (damages) {
    var rows = damages.filter(function (d) {
      return !d.deletedAt && !d.isCommonCostRow;
    });
    var groups = new Map();
    rows.forEach(function (damage) {
      if (!damage.sharedLalCost) return;
      var key = damage.sharedLalCost.id;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(damage);
    });
    groups.forEach(function (linked) {
      var cost = linked[0].sharedLalCost;
      var row = {
        _id: "common-lal-" + cost.id, isCommonCostRow: true,
        source: "Coût commun LAL", name: "LAL " + cost.ref,
        costContext: "Coût commun — sinistres affichés : " + linked.map(function (d) {
          return d.name;
        }).join(", "),
        refLal: cost.ref, dateDamage: cost.dateDamage,
        newCostTotal: cost.total, newCostInsurer: cost.insurer,
        costTotalLal: cost.insurer, newCostCompagny: cost.deductible,
        costDeductible: cost.deductible, backgroundColor: "#eaf4fa"
      };
      // Do not pretend a common dossier belongs to one arbitrary driver/group.
      ["customerName", "driverName", "vehicleName", "groupName", "managerName"].forEach(function (key) {
        var values = Array.from(new Set(linked.map(function (d) {
          return d[key];
        }).filter(Boolean)));
        row[key] = values.join(" / ");
      });
      rows.push(row);
    });
    return rows;
  };
  this.commonRows = function (damages, forExport) {
    var common = _this.withCommonRows(damages).filter(function (row) {
      return row.isCommonCostRow;
    });
    if (forExport || common.length <= 3) return common;
    // Keep the grid usable for clients with many multi-damage dossiers.
    // Excel retains one financial row per LAL, without this summary row.
    var summary = {
      _id: "common-lal-summary", isCommonCostRow: true, source: "Coûts communs LAL",
      name: "Coûts communs (" + common.length + " dossiers)",
      costContext: "Comptés une fois chacun — détail par référence dans l’export et les fiches sinistres",
      backgroundColor: "#eaf4fa"
    };
    ["newCostTotal", "newCostInsurer", "costTotalLal", "newCostCompagny", "costDeductible"].forEach(function (key) {
      summary[key] = round(common.reduce(function (sum, row) {
        return sum + (row[key] || 0);
      }, 0));
    });
    return [summary];
  };
});